import { QueryClient, QueryKey } from '@tanstack/react-query'
import {
  AISummary,
  AISummaryListResponse,
} from 'src/interfaces/aiSummary.interface'

/**
 * Writes the limit state the server just returned into every cached summary
 * list of one scope (prefix match), BEFORE the refetch lands. Without this the
 * "Generate New Summary" button was enabled again for the moment between a
 * successful generate and the refetch — and stayed enabled if that refetch
 * failed. The server stays the source of truth: callers still invalidate.
 *
 * - summary: a freshly generated summary to add as the newest tab
 * - nextAvailableAt: when this scope may generate again (24h countdown)
 */
export const applyAISummaryLimit = (
  queryClient: QueryClient,
  scopeKey: QueryKey,
  {
    nextAvailableAt,
    summary,
  }: { nextAvailableAt?: string | null; summary?: AISummary }
) => {
  if (!nextAvailableAt && !summary) return
  queryClient.setQueriesData<AISummaryListResponse>(
    { queryKey: scopeKey },
    (previous) => {
      if (!previous?.data) return previous
      const summaries = previous.data.summaries ?? []
      return {
        ...previous,
        data: {
          ...previous.data,
          ...(nextAvailableAt ? { nextAvailableAt, remainingToday: 0 } : {}),
          summaries:
            summary && !summaries.some((s) => s.id === summary.id)
              ? [...summaries, summary]
              : summaries,
        },
      }
    }
  )
}
